import {
  Bell,
  Download,
  FileText,
  FolderTree,
  LayoutDashboard,
  MessageCircle,
  Network,
  Search,
  Settings,
  Shield,
  Upload,
  Users,
} from 'lucide-react';

export interface NavItem {
  to: string;
  label: string;
  icon: typeof Users;
  permission: string;
  /** Hide unless tenant uses approval chains (progressive disclosure) */
  requiresApprovalChains?: boolean;
}

export interface NavGroup {
  label: string;
  icon?: typeof Users;
  permission?: string;
  children: NavItem[];
}

export type NavEntry = NavItem | NavGroup;

export function isNavGroup(entry: NavEntry): entry is NavGroup {
  return 'children' in entry;
}

export interface NavSection {
  title: string;
  items: NavEntry[];
}

export const SIDEBAR_SECTIONS: NavSection[] = [
  {
    title: 'Operación',
    items: [
      { to: '/dashboard', label: 'Inicio', icon: LayoutDashboard, permission: 'compliance.view' },
      { to: '/operations/compliance', label: 'Compliance', icon: Shield, permission: 'compliance.view' },
      { to: '/lookup', label: 'Consulta', icon: Search, permission: 'entity.view' },
      {
        label: 'Documentos',
        icon: FileText,
        children: [
          { to: '/documents', label: 'Bandeja', icon: FileText, permission: 'doc.view' },
          { to: '/documents?tab=approval', label: 'Aprobación', icon: Shield, permission: 'doc.approve' },
          { to: '/documents?tab=rejected', label: 'Rechazados', icon: FileText, permission: 'doc.view' },
        ],
      },
      {
        label: 'Equipos',
        icon: FolderTree,
        children: [
          { to: '/associations', label: 'Asociaciones', icon: FolderTree, permission: 'assoc.view' },
          { to: '/mi-requirente', label: 'Mis equipos', icon: FolderTree, permission: 'compliance.view' },
          { to: '/requirentes', label: 'Requirentes', icon: FolderTree, permission: 'req.manage' },
        ],
      },
      { to: '/notifications', label: 'Notificaciones', icon: Bell, permission: 'compliance.view' },
      { to: '/transferencias', label: 'Transferencias', icon: Users, permission: 'entity.transfer' },
    ],
  },
  {
    title: 'Estructura',
    items: [
      { to: '/entities', label: 'Entidades', icon: Users, permission: 'entity.view' },
      { to: '/contexts', label: 'Contextos', icon: FolderTree, permission: 'entity.view' },
      { to: '/tags', label: 'Tags', icon: FolderTree, permission: 'entity.view' },
      { to: '/relationships', label: 'Mapa de relaciones', icon: Network, permission: 'entity.view' },
    ],
  },
  {
    title: 'Datos',
    items: [
      { to: '/imports', label: 'Importaciones', icon: Upload, permission: 'import.run' },
      { to: '/exports', label: 'Exportaciones', icon: Download, permission: 'export.run' },
    ],
  },
  {
    title: 'Configuración',
    items: [
      { to: '/config/entity-types', label: 'Tipos de entidad', icon: Settings, permission: 'config.entity_types' },
      { to: '/config/document-types', label: 'Tipos de documento', icon: Settings, permission: 'config.document_types' },
      { to: '/config/association-types', label: 'Tipos de asociación', icon: Settings, permission: 'config.association_types' },
      { to: '/config/requirement-profiles', label: 'Plantillas', icon: Settings, permission: 'req.manage' },
      {
        to: '/config/approval-chains',
        label: 'Cadenas de aprobación',
        icon: Settings,
        permission: 'config.approval_chains',
        requiresApprovalChains: true,
      },
      { to: '/config/notification-rules', label: 'Reglas de notificación', icon: Bell, permission: 'config.notifications' },
      { to: '/config/tenant-visibility', label: 'Visibilidad (rama)', icon: Settings, permission: 'config.tenant_settings' },
    ],
  },
  {
    title: 'Admin',
    items: [
      { to: '/admin/users', label: 'Usuarios', icon: Users, permission: 'role.assign' },
      { to: '/admin/roles', label: 'Roles', icon: Shield, permission: 'role.manage' },
      { to: '/admin/whatsapp', label: 'WhatsApp', icon: MessageCircle, permission: 'whatsapp.admin' },
      { to: '/admin/audit', label: 'Audit log', icon: FileText, permission: 'audit.view' },
      { to: '/admin/privacy', label: 'Privacidad', icon: Shield, permission: 'privacy.erase' },
    ],
  },
];
